<template>
  <div class="align-items-end d-flex p-0 custom-radio-container">
    <div v-for="(item, indx) in Questionaries.options" :key="indx">
      <div
        class="text-center pointer rounded-top mb-0 custom-radio-button"
        :class="
          Questionaries.invalid == true
            ? 'bg-error'
            : item.check == true
            ? 'bg-green'
            : 'bg-gray'
        "
      >
        <div class="radio">
          <label class="w-100 mb-0">
            <input
              :id="`${id}-${indx}`"
              :disabled="isDisabled || item.disabled"
              :name="Questionaries.name + '-' + indx"
              type="radio"
              @click="Change(item)"
            />
            <span class="cr rounded-circle">
              <i
                class="cr-icon text-white"
                :class="item.check == true ? 'fa fa-check check-opacity' : ''"
              />
            </span>
          </label>
        </div>
        <span class="step-label">{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  meta: {
    description: 'Componente común personalizado CustomRadioButton, sólido.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  data() {
    return {
      Questionaries: this.questionLists,
      isDisabled: this.disabled,
    };
  },
  props: {
    id: {
      type: String,
      default: 'rbtnRadioButton',
      meta: {
        description: 'Id del Componente CustomRadioButton',
        example: 'IdCustomRadioButton',
      },
    },
    changeEvent: {
      type: Function,
      default: () => {},
      meta: {
        description: 'Evento que se dispara al seleccionar una opción',
        example: '',
      },
    },
    questionLists: {
      type: Object,
      default: new Object(),
      meta: {
        description:
          'Lista del componente que renderiza los radiobutton a visualizar',
        example: '',
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async Change(item) {
      let self = this;
      if (this.isDisabled) {
        return;
      }
      await self.Questionaries.options.map((val) => {
        if (val.label == item.label) {
          val.check = true;
        } else {
          val.check = false;
        }
      });

      self.Questionaries.invalid = !self.Questionaries.options.some(
        (elem) => elem.check == true
      );
      self.changeEvent(item);
    },
  },
  watch: {
    disabled: function() {
      this.isDisabled = this.disabled;
    },
  },
};
</script>

<style scoped>
.bg-error {
  background: #ffebeb 0% 0% no-repeat padding-box !important;
  border: 1px solid #c9545e !important;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
}

.bg-error .rounded-circle {
  border: 2px solid #c9545e !important;
  opacity: 1;
}

.bg-error .step-label {
  text-align: center;
  font: Regular 11px/13px Lato;
  letter-spacing: 0;
  color: #c9545e;
  opacity: 1;
}

.pointer {
  cursor: pointer;
}
.question {
  box-shadow: -3px 1px 3px #00000029;
  align-content: space-between;
}

.bg-gray {
  background: #f2f2f2;
}

.bg-green {
  background: #2db782;
}

/************* start of custom radio *****************/
.checkbox label:after,
.radio label:after {
  content: '';
  display: table;
  clear: both;
}

.checkbox .cr,
.radio .cr {
  position: relative;
  display: inline-block;
  border: 2px solid #a9a9a9;
  border-radius: 0.25em;
  width: 1.2em;
  height: 1.2em;
  margin-top: 4px;
}

.cr {
  border-radius: 50%;
}

.checkbox .cr .cr-icon,
.radio .cr .cr-icon {
  position: absolute;
  font-size: 0.7em;
  line-height: 0;
  top: 50%;
  left: 13%;
}

.cr-icon {
  margin-top: 0.04em;
}

.checkbox label input[type='checkbox'],
.radio label input[type='radio'] {
  display: none;
}

.checkbox label input[type='checkbox'] + .cr > .cr-icon,
.radio label input[type='radio'] + .cr > .cr-icon {
  opacity: 0;
}

.checkbox label input[type='checkbox']:checked + .cr > .cr-icon,
.radio label input[type='radio']:checked + .cr > .cr-icon {
  opacity: 1;
}

.checkbox label input[type='checkbox']:disabled + .cr,
.radio label input[type='radio']:disabled + .cr {
  opacity: 0.5;
}
.rounded-top {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-top-left-radius: 6px !important;
  border-top-right-radius: 6px !important;
}
/************* end of custom radio *****************/

label,
p {
  font-weight: normal;
}

.step-label {
  display: block;
  font: Regular 11px/11px Lato;
  font-size: 15px;
  letter-spacing: 0;
  color: #c9c9c9;
  font-weight: 100;
}

.bg-green .step-label {
  color: white;
}

.bg-green .radio .w-100 .cr.rounded-circle {
  border: 2px solid white;
  opacity: 1;
}

.step-label.active {
  color: #2db782;
  font-weight: bold;
}

.error-val {
  color: #ff5b5c;
  display: block;
  padding-left: 25px;
}

.success-val {
  color: #2db782;
  display: block;
}

.warning-val {
  color: #af6708;
  display: block;
}

.question-number-sup {
  font: 21px Lato;
  letter-spacing: 0;
  color: #ffffff;
}

.custom-control-label.font {
  font: 400 16px/19px Lato;
  color: #11291b;
  padding-top: 4px;
}

.custom-radio-container .custom-radio-button {
  width: 92px;
  margin-right: 8px;
}
.check-opacity {
  opacity: 1 !important;
}
</style>
